import gql from 'graphql-tag'
import client from '@stores/apollo'
import { UpdateFloorAssetsVersionInput } from '@api'

export default function update(input: UpdateFloorAssetsVersionInput) {
  return client.gql.mutate({ mutation, variables: { input } })
}

const mutation = gql`
  mutation updateFloorAsset($input: UpdateFloorAssetsVersionInput!) {
    updateFloorAssetsVersion(input: $input) {
      blockInstances {
        id
        block {
          id
          url
          guid
        }
        map {
          x
          y
          h
          w
          rotation
        }
      }
    }
  }
`
